module.exports = __webpack_public_path__ + "img/lcr0005jp01.5acf8761.jpg";